import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Dropdown } from 'floating-vue'
import DropdownMenuItem from '@/layouts/AppLayoutHeader/components/DropdownMenuItem.vue'
import LanguageDropdownSelector from './LanguageDropdownSelector.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageDropdown',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dropdown), { placement: "right-end" }, {
    popper: _withCtx(() => [
      _createVNode(LanguageDropdownSelector)
    ]),
    default: _withCtx(() => [
      _createVNode(DropdownMenuItem, { icon: "globe-icon" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('sidebar.language')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})